import Qs from "qs";

export const APP_ENV = process.env.APP_ENV;

import { CurrentEnvPrefix } from "config/urlprefix.js";

export default {
  url: "/route",

  baseURL: CurrentEnvPrefix.mainApi, //http://192.168.2.105:3006/v1//http://apistaging.zhaojiafang.com/v1//http://api.zhaojiafang.com/v1

  transformRequest: [
    function(data) {
      // 为了避免qs格式化时对内层对象的格式化先把内层的对象转为
      data.CustData = JSON.stringify(data.CustData);
      // 由于使用的form-data传数据所以要格式化
      data = Qs.stringify(data);
      return data;
    }
  ],

  transformResponse: [
    function(data) {
      return data;
    }
  ],

  headers: { "Content-Type": "application/x-www-form-urlencoded" },

  authparams: {
    AppVersion: "3.11",
    Format: "json",
    SystemName: "PC",
    key: "",
    storeid: "0",
    SignCodeKey: "H5SIGNKEYZJFk3029ydhsuwei192bmch",
    timestamp: new Date().getTime(),
    nosign: "nodejs.sign.no"
  },

  params: {},

  data: {},

  timeout: 60000,

  withCredentials: false, // default

  responseType: "json", // default

  maxContentLength: 2000,

  maxRedirects: 5, // default

  paramsSerializer: function(params) {
    return Qs.stringify(params);
  },

  onUploadProgress: function(progressEvent) {
    // Do whatever you want with the native progress event
  },
  onDownloadProgress: function(progressEvent) {
    // Do whatever you want with the native progress event
  },

  validateStatus: function(status) {
    return status >= 200 && status < 300; // default
  }
};



// WEBPACK FOOTER //
// ./src/api/config.js